export default "__VITE_ASSET__CTYhXX1d__"